module.exports = __webpack_public_path__ + "img/JT_icons01_64px_EliteUser.39e06508.svg";